import * as React from 'react'

export const ReloadElement = ({ setReload }) => {
  setTimeout(() => {
    setReload(false)
  })
  return null
}
